import React from "react";
import Slider from "react-slick";
import "./BannerCarousel.css"; // Aquí pones los estilos personalizados
import logoBanner from '../../../Assests/4f71dc90cc29b4ed69de0636891985f083fdf283.png'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function BannerCarousel({ background, urlApiServerImage }) {
    console.log("background: ", background)
    const settings = {
        dots: true,
        infinite: true,
        speed: 800,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: false,
        fade: true
    };

    return (
        <Slider {...settings}>
            {background?.map((item, index) => (
                <div key={index}>
                    {
                        console.log("itemmmmm: ", urlApiServerImage + item?.url)
                    }
                    <div
                        className="bannerContainer"
                        style={{
                            backgroundImage: `url(${urlApiServerImage + item?.url})`
                        }}
                    >
                        <img src={logoBanner} alt="logoBanner" className="logoBanner" />
                    </div>
                </div>
            ))}
        </Slider>
    );
}

export default BannerCarousel;
